import React, { useEffect, useRef, useState } from "react";
import "bootstrap-daterangepicker/daterangepicker.css";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { getAllCurrencyAsync, CurrencyActions } from "../redux";
import {
  Card,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import CurrencyTable from "./currency_detail/currencyTable";
import CurrencyEdit from "./currency_detail/currencyEdit";

export function CurrencyManagement() {
  const [showAddTemplate, setShowAddTemplate] = useState(false);
  const [showEditTemplete, setShowEditTemplate] = useState(false);
  const dispatch = useDispatch();
  const searchCurrencyRef = useRef();
  const type = "EMAIL";
  const { refreshList, search, searchText } = useSelector(
    (state) => state.currencyManagement,
    shallowEqual
  );
  //call api while search
  useEffect(() => {
    if (searchCurrencyRef.current) {
      let keyPressEvent = (e) => {
        if (e.keyCode === 13) {
          e.preventDefault();
          dispatch(CurrencyActions.refreshCurrencyList());
        }
      };
      let input = searchCurrencyRef.current;
      input.addEventListener("keyup", keyPressEvent);

      return () => {
        input.removeEventListener("keyup", keyPressEvent);
        dispatch(CurrencyActions.searchTextChange(""));
        input.value = "";
      };
    }
  }, []);
  useEffect(() => {
    if (refreshList) {
      dispatch(getAllCurrencyAsync(search, searchText, type)); //call api for get email list
    }
  }, [refreshList]);

  const onAddClick = () => {
    setShowAddTemplate(true);
  };
  //save edit email details
  const onEditClick = (email) => {
    dispatch(CurrencyActions.setSelectedCurrency(email));
    setShowEditTemplate(true);
  };
  //save search text
  const onSearchTextChange = (e) => {
    dispatch(CurrencyActions.searchTextChange(e.target.value));
  };

  return (
    <>
      <Card>
        <CardHeader title="Currencies">
          <CardHeaderToolbar>
            <div className="d-flex flex-wrap ap_filter_wraper justify-content-end align-items-center">
              <form
                autoComplete="off"
                className="subheader_filter"
                onSubmit={(e) => e.preventDefault()}
              >
                <div className="form-row">
                  {/* <div className="form-group mr-5 mb-1 mt-2">
                    <button
                      className="btn_new btn-sm"
                      type="button"
                      onClick={() => onAddClick()}
                    >
                      Add
                    </button>
                  </div> */}
                  <div className="form-group mr-3 mb-1">
                    <input
                      name="Search"
                      placeholder="Search. . ."
                      type="text"
                      className="form-control"
                      value={searchText}
                      onChange={onSearchTextChange}
                      ref={searchCurrencyRef}
                    />
                  </div>
                </div>
              </form>
            </div>
          </CardHeaderToolbar>
        </CardHeader>
        <CurrencyTable onEditClick={onEditClick} />
        {/* <AddCurrency
          setShowAddTemplate={setShowAddTemplate}
          showAddTemplate={showAddTemplate}
        /> */}
        <CurrencyEdit
          showEditTemplete={showEditTemplete}
          setShowEditTemplate={setShowEditTemplate}
        />
      </Card>
    </>
  );
}
